import { render, staticRenderFns } from "./MenuEstimate.vue?vue&type=template&id=2ec1d288"
import script from "./MenuEstimate.vue?vue&type=script&lang=js"
export * from "./MenuEstimate.vue?vue&type=script&lang=js"
import style0 from "./MenuEstimate.vue?vue&type=style&index=0&id=2ec1d288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports